
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import ReferralLinkTrackingReport from '@/components/reports/ReferralLinkTrackingReport';
import { useAuth } from '@/context/SupabaseAuthContext';
import BackToDashboardButton from '@/components/navigation/BackToDashboardButton';

const ReferralLinkTrackingPage = () => {
  const navigate = useNavigate();
  const { logoutUser } = useAuth();
  
  return (
    <DashboardLayout onLogout={logoutUser}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <BackToDashboardButton />
        
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Referral Link Tracking</h1>
          <p className="text-gray-600">See detailed analytics about your referral links</p>
        </div>
        
        <div className="space-y-6">
          <ReferralLinkTrackingReport />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ReferralLinkTrackingPage;
